import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetTransactionTranslations  {
    _originalTypeClassName = "zERP.BO.AssetTransactionTranslations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetTransactionTranslations.translate = translateService;
}
this.AssetTransactionTranslationsKey = null;
this._key = this.AssetTransactionTranslationsKey = 0; 
}

static translate: TranslateService;
_key: any;
private _AssetTransactionTranslationsKey:any;
get AssetTransactionTranslationsKey(): any {
    return this._AssetTransactionTranslationsKey;
  }
set AssetTransactionTranslationsKey(value: any) {
    this._AssetTransactionTranslationsKey = value;
    this._key = value;
  }

static TransactionType(type: any): any{switch ((type)) {case Domain.AssetTransactionType.Acquisition:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Acquisition');}
case Domain.AssetTransactionType.Adjustment:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Adjustment');}
case Domain.AssetTransactionType.Depreciation:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Depreciation');}
case Domain.AssetTransactionType.Destruction:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Destruction');}
case Domain.AssetTransactionType.Improvement:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Improvement');}
case Domain.AssetTransactionType.Sale:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Sale');}
case Domain.AssetTransactionType.Settlement:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Settlement');}
case Domain.AssetTransactionType.Trading:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Trading');}
case Domain.AssetTransactionType.Transfer:
{
return this.translate.instant('Res_ENUM_AssetTransactionType_Transfer');}
default:
{
throw Error("Transaction type not found");}
}
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetTransactionTranslationsKey == null || $this.AssetTransactionTranslationsKey == 0;
            }


}